import {
  BASE_MOBILE_NAV_HEIGHT,
  BASE_MOBILE_PADDING_Y,
  DESKTOP_NAV_HEIGHT,
  HEADER_HEIGHT,
  IOS_MOBILE_PADDING_BOTTOM,
} from "@constants/layout";
import { getDevicePlatform, isStandalonePwa } from "@utils/environment";

export const getHeaderHeight = (isMobile: boolean): number => {
  return isMobile ? HEADER_HEIGHT : HEADER_HEIGHT + DESKTOP_NAV_HEIGHT;
};

export const getMobileNavHeight = (): number => {
  return BASE_MOBILE_NAV_HEIGHT + 2 * getMobilePaddingY();
};

export const getMobilePaddingY = (): number => {
  const platform = getDevicePlatform();
  const isStandalone = isStandalonePwa();
  const hasIOSBottomNav = platform === "ios" && isStandalone;

  if (hasIOSBottomNav) {
    return BASE_MOBILE_PADDING_Y + IOS_MOBILE_PADDING_BOTTOM;
  }

  return BASE_MOBILE_PADDING_Y;
};
